import { jsx as _jsx } from "react/jsx-runtime";
import { HighlighterElement } from './styles';
export default function Highlighter({ searchWords, textToHighlight, testId }) {
    return (_jsx(HighlighterElement, { autoEscape: true, "data-testid": testId, searchWords: searchWords, textToHighlight: textToHighlight }));
}
